import React from 'react'

const Footer = () => {
  return (
    <footer >
      <div className="container">

        <p className='pb-3 pt-4 mb-0 text-center text-white fw-light'>&copy; {new Date().getFullYear()} Dscode - Todos los derechos reservados. <br /> Designed by <a className='text-white' href="https://www.instagram.com/dscode.py/" target="_blank" rel="noreferrer">DsCode</a></p>
      </div>

    </footer>

  )
}

export default Footer